export const generatedScenarioNotebookPack = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-scenario-notebook-pack",
  "operatingRule": "Every scenario has a hash-backed notebook for reviewer inspection. Generated coverage-gap notebooks are explicit placeholders and are blocked from customer/commercial use until expanded and approved.",
  "scenarioCount": 6,
  "notebookCount": 6,
  "sourceDefinedNotebookCount": 3,
  "generatedCoverageGapNotebookCount": 3,
  "customerUseAllowed": false,
  "commercialUseAllowed": false,
  "evidenceHashes": {
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
    "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
    "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
    "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
    "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
    "sourceNotebookSet": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
  },
  "notebooks": [
    {
      "id": "scenario-notebook-hybrid",
      "scenarioId": "hybrid",
      "scenarioName": "Hybrid Moon -> Asteroid -> Mercury",
      "title": "Hybrid Moon -> Asteroid -> Mercury generated review notebook",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "notebookState": "generated-coverage-gap-notebook",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "audience": "scenario feasibility reviewer",
      "sourceNotebookId": null,
      "sourceNotebookCoverage": "generated-gap-cover",
      "decision": {
        "rank": 2,
        "decisionLane": "lane-3-watchlist",
        "decisionReadinessScore": 59.78,
        "deterministicUtility": 65.69,
        "promotionState": "blocked-for-commercial-proof",
        "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803",
        "comparisonHash": "sha256-c765fca1e18763bf995923b987883f1e0df592a1e5fd6009a0036b99492bbba0"
      },
      "uncertainty": {
        "uncertaintyBudgetPoints": 43.88,
        "uncertaintyClass": "medium-uncertainty",
        "utilityP10": 63.32,
        "utilityMedian": 65.48,
        "utilityP90": 67.6,
        "topDrivers": [
          {
            "category": "model-spread",
            "label": "Seeded utility downside spread",
            "contributionPoints": 10.68,
            "evidenceState": "modeled-heuristic",
            "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
            "contributionHash": "sha256-1113356c45a9d66efb46dd79ad7e995ce35753fd92106e8a62a123e46e0c609a"
          },
          {
            "category": "assumption-sensitivity",
            "label": "Blocked or sensitive assumptions",
            "contributionPoints": 9.66,
            "evidenceState": "blocked-business-proof",
            "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
            "contributionHash": "sha256-4e70a0f224a6884c44ccdf9a653d574034fb8de4a78ea8dafb4b627c42b51d72"
          },
          {
            "category": "resource-evidence",
            "label": "Body/feedstock composition uncertainty",
            "contributionPoints": 9.5,
            "evidenceState": "blocked-resource-promotion",
            "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
            "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
            "contributionHash": "sha256-07a08f8b629617090c595a9abaae19c858d1033775537f967bec618d3b525523"
          },
          {
            "category": "runtime-sidecar",
            "label": "Trajectory/event/runtime validation gap",
            "contributionPoints": 6.5,
            "evidenceState": "blocked-runtime-evidence",
            "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
            "contributionHash": "sha256-d252d3d9ee2efe620e142b4d9d979748aff8a080a03247b343b412a2fac70d80"
          }
        ],
        "budgetHash": "sha256-d595ef57fc29b1e7bf00950455c56c83e9f708dd12dd6c63c2d8c22b72a89869"
      },
      "economics": {
        "businessReadinessMedian": 72.59,
        "businessReadinessP10": 66.95,
        "businessReadinessP90": 78.5,
        "medianProgramNeedBn": 61.38,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 24.22,
        "underfundedProbabilityPercent": 0.39
      },
      "sourceRefs": [],
      "artifactIds": [],
      "assumptionRefs": [],
      "openQuestions": [
        "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "Close assumption review gates with source-backed records and rerun assumption impact ledger."
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "No source-authored scenario notebook existed in the snapshot; this generated notebook requires reviewer expansion before customer use."
      ],
      "workOrders": [
        {
          "id": "diligence-work-order-01-gap-runtime-orekit-propagation-v1",
          "coverage": "direct-scenario-work-order",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "workOrderHash": "sha256-baa82fd4ea74aad62b55dfc56fd78e1513cac8ba3a0e6cbc136c02b3d128e4d1"
        },
        {
          "id": "diligence-work-order-02-gap-runtime-gmat-transfer-v1",
          "coverage": "direct-scenario-work-order",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "workOrderHash": "sha256-571ba2ce848959e9016799486d0505720f857685f02a601c2cc09e7f58a3e476"
        },
        {
          "id": "diligence-work-order-03-gap-runtime-tudat-transfer-v1",
          "coverage": "direct-scenario-work-order",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "workOrderHash": "sha256-74ae877ca9b3c8c030f093f9b35cfd3239f6069c924c1f0da02bf9b6c1d98710"
        },
        {
          "id": "diligence-work-order-04-gap-materials-process-oxygen-isru",
          "coverage": "direct-scenario-work-order",
          "lane": "process-physics",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
          "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
          "workOrderHash": "sha256-bdf99d78b39494df13a8409aa9336affd690e24fd93ec58fdc5b56e258143622"
        },
        {
          "id": "diligence-work-order-05-gap-readiness-science-math-credibility",
          "coverage": "direct-scenario-work-order",
          "lane": "release-proof",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Required to raise the beta from testable to release-grade.",
          "nextAction": "Source Registry 2.0, assumption registry, scenario notebooks, generated model-artifact bundles, seeded scenario uncertainty analysis, generated economics frontier artifacts, business-case planning heuristics, one SPICE GF runtime artifact, and one OpenMDAO/Dymos beta optimization artifact are now local and tested, but Orekit/GMAT/Tudat runtime artifacts are not yet generated.",
          "workOrderHash": "sha256-6e0809c818212af1f7017609be842f01e31c381d04b54fc7f66db8f75606e2d6"
        },
        {
          "id": "diligence-work-order-06-gap-candidate-source-2026-em",
          "coverage": "direct-scenario-work-order",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
          "workOrderHash": "sha256-ca289d3590ea16900ade0899719bc6f367b45d272c91c2e61f4110ea941a5e16"
        },
        {
          "id": "diligence-work-order-07-gap-candidate-source-2026-jm2",
          "coverage": "direct-scenario-work-order",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
          "workOrderHash": "sha256-708045573dcd7b1b11a8d0644a1306575d7ae399481f6842235f66802c679332"
        },
        {
          "id": "diligence-work-order-08-gap-candidate-source-2026-dn5",
          "coverage": "direct-scenario-work-order",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
          "workOrderHash": "sha256-7aba6c179ff641753e4dcf699a4c2e196f07d7a2ebadbb931690035802d2f143"
        },
        {
          "id": "diligence-work-order-09-gap-materials-process-spf-db",
          "coverage": "direct-scenario-work-order",
          "lane": "process-physics",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
          "nextAction": "Promote reviewed material records and thermal cycle energy balance for Superplastic Forming / Diffusion Bonding.",
          "workOrderHash": "sha256-0f76d2cba16f3e50d606a4ca6ba58e7b0b55ff94806314a9f1fc37a2016034b4"
        },
        {
          "id": "diligence-work-order-10-gap-materials-process-vacuum-sheet",
          "coverage": "direct-scenario-work-order",
          "lane": "process-physics",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
          "nextAction": "Promote reviewed material records and MOOSE thermo-mechanical forming residual record for Vacuum Anisotropic Sheet Manufacturing.",
          "workOrderHash": "sha256-ef9e747934d358294e2459299e33ef07454fd7880972a251177e083cda4c7169"
        },
        {
          "id": "diligence-work-order-11-gap-resource-taxonomy-spectra-record",
          "coverage": "direct-scenario-work-order",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
          "workOrderHash": "sha256-ce13be2de8e222b90b3f72ab64e82567f72bc328ddf50d0cdf34b08ecf7cd089"
        },
        {
          "id": "diligence-work-order-12-gap-economics-launch-list-price-source",
          "coverage": "direct-scenario-work-order",
          "lane": "economics-sensitivity",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Do dated, normalized cost and market inputs change the scenario ranking or capital gap?",
          "nextAction": "Normalize launch-cost records into model-ready numeric inputs with calibration artifacts.",
          "workOrderHash": "sha256-98529615ecd1f236b1f6ea583e4019269b6871fe39b3b94d8d0dc2b797ce60e6"
        }
      ],
      "evidenceHashes": {
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "sourceNotebookSet": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
      },
      "markdownPath": "public/scenario-notebooks/scenario-notebook-hybrid.md",
      "notebookHash": "sha256-c5fb32fd34a29db9e178b2332ba46aa1b2a6b2de7da528e1dd79d26287685a27",
      "markdownHash": "sha256-7a976b1c0e4f2a23cd3c3ccba2c80da1e0863069c600c3a4c8114be1a612296b"
    },
    {
      "id": "scenario-notebook-moon-first",
      "scenarioId": "moon-first",
      "scenarioName": "Moon-first Bootstrap",
      "title": "Moon-first industrial bootstrap",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "notebookState": "source-backed-review-notebook",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "audience": "near-term feasibility reviewer",
      "sourceNotebookId": "notebook-moon-first",
      "sourceNotebookCoverage": "source-defined",
      "decision": {
        "rank": 1,
        "decisionLane": "lane-2-conditional-diligence",
        "decisionReadinessScore": 62.91,
        "deterministicUtility": 67.12,
        "promotionState": "blocked-for-commercial-proof",
        "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c",
        "comparisonHash": "sha256-0e20a4f32e1fffc791e70ee9d42ae561995b00859acf3c54885589cc755b07b5"
      },
      "uncertainty": {
        "uncertaintyBudgetPoints": 29.81,
        "uncertaintyClass": "managed-beta-uncertainty",
        "utilityP10": 65.24,
        "utilityMedian": 67.03,
        "utilityP90": 68.88,
        "topDrivers": [
          {
            "category": "model-spread",
            "label": "Seeded utility downside spread",
            "contributionPoints": 7.99,
            "evidenceState": "modeled-heuristic",
            "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
            "contributionHash": "sha256-e7a820a5533b534b98eb2282a217d51581e38dab0711cf9ec220ba7993bab383"
          },
          {
            "category": "runtime-sidecar",
            "label": "Trajectory/event/runtime validation gap",
            "contributionPoints": 6.5,
            "evidenceState": "blocked-runtime-evidence",
            "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
            "contributionHash": "sha256-d252d3d9ee2efe620e142b4d9d979748aff8a080a03247b343b412a2fac70d80"
          },
          {
            "category": "assumption-sensitivity",
            "label": "Blocked or sensitive assumptions",
            "contributionPoints": 6.44,
            "evidenceState": "blocked-business-proof",
            "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
            "contributionHash": "sha256-27860bb055c03086a261c1eb072bb63d5c7b6df40ac68d67afe85cc9d2f71730"
          },
          {
            "category": "source-use-rights",
            "label": "Customer report source-use clearance",
            "contributionPoints": 6.13,
            "evidenceState": "blocked-source-use-review",
            "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
            "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
            "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
          }
        ],
        "budgetHash": "sha256-7500ba6f2d84d04fb1ca29f147b51a1837dea22ff94c58685f367d997e50a621"
      },
      "economics": {
        "businessReadinessMedian": 76.65,
        "businessReadinessP10": 71.87,
        "businessReadinessP90": 81.23,
        "medianProgramNeedBn": 49.36,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 75.78,
        "underfundedProbabilityPercent": 0
      },
      "sourceRefs": [
        {
          "id": "pds",
          "title": null,
          "sourceType": null,
          "domain": null,
          "license": null
        },
        {
          "id": "nasa-dtn",
          "title": null,
          "sourceType": null,
          "domain": null,
          "license": null
        }
      ],
      "artifactIds": [
        "artifact-economics-uncertainty-v1",
        "artifact-materials-process-v1"
      ],
      "assumptionRefs": [],
      "openQuestions": [
        "Polar volatile access",
        "power storage",
        "surface logistics",
        "customer demand",
        "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "Promote runtime sidecar artifacts through the sidecar validation gate."
      ],
      "blockers": [
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for moon-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for moon-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof"
      ],
      "workOrders": [
        {
          "id": "diligence-work-order-04-gap-materials-process-oxygen-isru",
          "coverage": "direct-scenario-work-order",
          "lane": "process-physics",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
          "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
          "workOrderHash": "sha256-bdf99d78b39494df13a8409aa9336affd690e24fd93ec58fdc5b56e258143622"
        },
        {
          "id": "diligence-work-order-12-gap-economics-launch-list-price-source",
          "coverage": "direct-scenario-work-order",
          "lane": "economics-sensitivity",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Do dated, normalized cost and market inputs change the scenario ranking or capital gap?",
          "nextAction": "Normalize launch-cost records into model-ready numeric inputs with calibration artifacts.",
          "workOrderHash": "sha256-98529615ecd1f236b1f6ea583e4019269b6871fe39b3b94d8d0dc2b797ce60e6"
        }
      ],
      "evidenceHashes": {
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "sourceNotebookSet": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
      },
      "markdownPath": "public/scenario-notebooks/scenario-notebook-moon-first.md",
      "notebookHash": "sha256-9c0b7cfcfe683476716b9793eac869b8cc52373b2f67513a58f862a2260e4dd8",
      "markdownHash": "sha256-066b51bdc7f3d225a39921c15d834a53e3b8b07cfbf17f46afdd5f4622cfc9e1"
    },
    {
      "id": "scenario-notebook-asteroid-first",
      "scenarioId": "asteroid-first",
      "scenarioName": "Asteroid Feedstock-first",
      "title": "NEA feedstock screening",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "notebookState": "source-backed-review-notebook",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "audience": "resource and logistics reviewer",
      "sourceNotebookId": "notebook-asteroid-feedstock",
      "sourceNotebookCoverage": "source-defined",
      "decision": {
        "rank": 3,
        "decisionLane": "lane-4-research-backlog",
        "decisionReadinessScore": 41.63,
        "deterministicUtility": 51.37,
        "promotionState": "blocked-for-commercial-proof",
        "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051",
        "comparisonHash": "sha256-84608e1ed73d3da4c7c87c790bed8b11dd803804546ddad327dc99882b646aef"
      },
      "uncertainty": {
        "uncertaintyBudgetPoints": 62.38,
        "uncertaintyClass": "high-uncertainty",
        "utilityP10": 48.31,
        "utilityMedian": 51.44,
        "utilityP90": 54.65,
        "topDrivers": [
          {
            "category": "model-spread",
            "label": "Seeded utility downside spread",
            "contributionPoints": 15.7,
            "evidenceState": "modeled-heuristic",
            "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
            "contributionHash": "sha256-62290db47bb715a394703feface42956bd76762cc46e41871be2d4c6088926f8"
          },
          {
            "category": "runtime-sidecar",
            "label": "Trajectory/event/runtime validation gap",
            "contributionPoints": 12,
            "evidenceState": "blocked-runtime-evidence",
            "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
            "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
          },
          {
            "category": "resource-evidence",
            "label": "Body/feedstock composition uncertainty",
            "contributionPoints": 11.2,
            "evidenceState": "blocked-resource-promotion",
            "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
            "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
            "contributionHash": "sha256-2c261a74b574903f533b54dbb876ed54b89344637cb324d566afd587e6fb1ec9"
          },
          {
            "category": "assumption-sensitivity",
            "label": "Blocked or sensitive assumptions",
            "contributionPoints": 10.74,
            "evidenceState": "blocked-business-proof",
            "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
            "contributionHash": "sha256-4d1eb074e43d03e1bb3481de720554475dcffbd6811c616684e790a98fc50a62"
          }
        ],
        "budgetHash": "sha256-aeeeb361235a90a7df3c4136154cb8901a3573712450f7d0879a212ebf0fe17a"
      },
      "economics": {
        "businessReadinessMedian": 59.76,
        "businessReadinessP10": 52.92,
        "businessReadinessP90": 67.27,
        "medianProgramNeedBn": 70,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 0,
        "underfundedProbabilityPercent": 2.73
      },
      "sourceRefs": [
        {
          "id": "sbdb-api",
          "title": null,
          "sourceType": null,
          "domain": null,
          "license": null
        },
        {
          "id": "cad-api",
          "title": null,
          "sourceType": null,
          "domain": null,
          "license": null
        },
        {
          "id": "pds",
          "title": null,
          "sourceType": null,
          "domain": null,
          "license": null
        }
      ],
      "artifactIds": [
        "artifact-sbdb-cad-screen-v1",
        "artifact-trajectory-sidecar-v1"
      ],
      "assumptionRefs": [],
      "openQuestions": [
        "Composition evidence",
        "low-vinf cadence",
        "processing site",
        "returned material value",
        "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "Promote runtime sidecar artifacts through the sidecar validation gate."
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for asteroid-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Candidate-specific SBDB/CAD/taxonomy/spectra evidence required before resource promotion."
      ],
      "workOrders": [
        {
          "id": "diligence-work-order-06-gap-candidate-source-2026-em",
          "coverage": "direct-scenario-work-order",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
          "workOrderHash": "sha256-ca289d3590ea16900ade0899719bc6f367b45d272c91c2e61f4110ea941a5e16"
        },
        {
          "id": "diligence-work-order-07-gap-candidate-source-2026-jm2",
          "coverage": "direct-scenario-work-order",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
          "workOrderHash": "sha256-708045573dcd7b1b11a8d0644a1306575d7ae399481f6842235f66802c679332"
        },
        {
          "id": "diligence-work-order-08-gap-candidate-source-2026-dn5",
          "coverage": "direct-scenario-work-order",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
          "workOrderHash": "sha256-7aba6c179ff641753e4dcf699a4c2e196f07d7a2ebadbb931690035802d2f143"
        },
        {
          "id": "diligence-work-order-11-gap-resource-taxonomy-spectra-record",
          "coverage": "direct-scenario-work-order",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
          "workOrderHash": "sha256-ce13be2de8e222b90b3f72ab64e82567f72bc328ddf50d0cdf34b08ecf7cd089"
        }
      ],
      "evidenceHashes": {
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "sourceNotebookSet": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
      },
      "markdownPath": "public/scenario-notebooks/scenario-notebook-asteroid-first.md",
      "notebookHash": "sha256-5a34fd0fd79033b3580e120c3a4113a8c7647231f7caff7af92027f1ff77893b",
      "markdownHash": "sha256-35e41eae575079217dfc396569f161dcf0012edc6bf222ad5c802a9991887258"
    },
    {
      "id": "scenario-notebook-mercury-orbit",
      "scenarioId": "mercury-orbit",
      "scenarioName": "Mercury Orbit-first",
      "title": "Mercury-orbit energy and thermal trade",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "notebookState": "source-backed-review-notebook",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "audience": "high-energy manufacturing reviewer",
      "sourceNotebookId": "notebook-mercury-orbit",
      "sourceNotebookCoverage": "source-defined",
      "decision": {
        "rank": 4,
        "decisionLane": "lane-4-research-backlog",
        "decisionReadinessScore": 44.15,
        "deterministicUtility": 42.95,
        "promotionState": "blocked-for-commercial-proof",
        "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4",
        "comparisonHash": "sha256-8193cf633a9652086e465ca272495519c9ca24c4aac0c1911fa94631105ef6e4"
      },
      "uncertainty": {
        "uncertaintyBudgetPoints": 65.61,
        "uncertaintyClass": "high-uncertainty",
        "utilityP10": 39.63,
        "utilityMedian": 42.76,
        "utilityP90": 46.47,
        "topDrivers": [
          {
            "category": "model-spread",
            "label": "Seeded utility downside spread",
            "contributionPoints": 16,
            "evidenceState": "modeled-heuristic",
            "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
            "contributionHash": "sha256-3a6bcd76e44b465731a5a7391ff59f7e8c4b01803bf85738d9eeacfda0260026"
          },
          {
            "category": "runtime-sidecar",
            "label": "Trajectory/event/runtime validation gap",
            "contributionPoints": 12,
            "evidenceState": "blocked-runtime-evidence",
            "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
            "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
          },
          {
            "category": "assumption-sensitivity",
            "label": "Blocked or sensitive assumptions",
            "contributionPoints": 11.82,
            "evidenceState": "blocked-business-proof",
            "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
            "contributionHash": "sha256-c7a1e79ea5ee80f6e71b08dd891825dc28d5ad7f6a6250d69309b5965aa8aff6"
          },
          {
            "category": "resource-evidence",
            "label": "Body/feedstock composition uncertainty",
            "contributionPoints": 11,
            "evidenceState": "blocked-resource-promotion",
            "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
            "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
            "contributionHash": "sha256-d23405c06a904d5d1e4f33ec35240bb179a08e65ed69c7c42149c071a8824cf7"
          }
        ],
        "budgetHash": "sha256-70c464f33b48019386facb39aa0bfb479741a7cbb3dfba4dda52f3293de0512a"
      },
      "economics": {
        "businessReadinessMedian": 55.33,
        "businessReadinessP10": 45.88,
        "businessReadinessP90": 64.63,
        "medianProgramNeedBn": 97.54,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 0,
        "underfundedProbabilityPercent": 10.94
      },
      "sourceRefs": [
        {
          "id": "horizons-api",
          "title": null,
          "sourceType": null,
          "domain": null,
          "license": null
        },
        {
          "id": "spice-gf",
          "title": null,
          "sourceType": null,
          "domain": null,
          "license": null
        },
        {
          "id": "nasa-mercury",
          "title": null,
          "sourceType": null,
          "domain": null,
          "license": null
        }
      ],
      "artifactIds": [
        "artifact-horizons-geometry-v1",
        "artifact-spice-gf-windows-v1"
      ],
      "assumptionRefs": [],
      "openQuestions": [
        "Thermal rejection",
        "solar interference windows",
        "transport burden",
        "resource proof",
        "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "Promote runtime sidecar artifacts through the sidecar validation gate."
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mercury-orbit: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof"
      ],
      "workOrders": [
        {
          "id": "diligence-work-order-01-gap-runtime-orekit-propagation-v1",
          "coverage": "direct-scenario-work-order",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "workOrderHash": "sha256-baa82fd4ea74aad62b55dfc56fd78e1513cac8ba3a0e6cbc136c02b3d128e4d1"
        },
        {
          "id": "diligence-work-order-02-gap-runtime-gmat-transfer-v1",
          "coverage": "direct-scenario-work-order",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "workOrderHash": "sha256-571ba2ce848959e9016799486d0505720f857685f02a601c2cc09e7f58a3e476"
        },
        {
          "id": "diligence-work-order-03-gap-runtime-tudat-transfer-v1",
          "coverage": "direct-scenario-work-order",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "workOrderHash": "sha256-74ae877ca9b3c8c030f093f9b35cfd3239f6069c924c1f0da02bf9b6c1d98710"
        },
        {
          "id": "diligence-work-order-05-gap-readiness-science-math-credibility",
          "coverage": "direct-scenario-work-order",
          "lane": "release-proof",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Required to raise the beta from testable to release-grade.",
          "nextAction": "Source Registry 2.0, assumption registry, scenario notebooks, generated model-artifact bundles, seeded scenario uncertainty analysis, generated economics frontier artifacts, business-case planning heuristics, one SPICE GF runtime artifact, and one OpenMDAO/Dymos beta optimization artifact are now local and tested, but Orekit/GMAT/Tudat runtime artifacts are not yet generated.",
          "workOrderHash": "sha256-6e0809c818212af1f7017609be842f01e31c381d04b54fc7f66db8f75606e2d6"
        },
        {
          "id": "diligence-work-order-09-gap-materials-process-spf-db",
          "coverage": "direct-scenario-work-order",
          "lane": "process-physics",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
          "nextAction": "Promote reviewed material records and thermal cycle energy balance for Superplastic Forming / Diffusion Bonding.",
          "workOrderHash": "sha256-0f76d2cba16f3e50d606a4ca6ba58e7b0b55ff94806314a9f1fc37a2016034b4"
        },
        {
          "id": "diligence-work-order-10-gap-materials-process-vacuum-sheet",
          "coverage": "direct-scenario-work-order",
          "lane": "process-physics",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
          "nextAction": "Promote reviewed material records and MOOSE thermo-mechanical forming residual record for Vacuum Anisotropic Sheet Manufacturing.",
          "workOrderHash": "sha256-ef9e747934d358294e2459299e33ef07454fd7880972a251177e083cda4c7169"
        }
      ],
      "evidenceHashes": {
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "sourceNotebookSet": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
      },
      "markdownPath": "public/scenario-notebooks/scenario-notebook-mercury-orbit.md",
      "notebookHash": "sha256-74496d40f3646ea99f9a964c2f14a678f0db303a05888664c809d8c30bc32b92",
      "markdownHash": "sha256-63e93e868478bdeb813beeeaccb16d2856edfbcc83028c6551c39028a7941ef1"
    },
    {
      "id": "scenario-notebook-mercury-polar",
      "scenarioId": "mercury-polar",
      "scenarioName": "Mercury Polar Surface-first",
      "title": "Mercury Polar Surface-first generated review notebook",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "notebookState": "generated-coverage-gap-notebook",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "audience": "scenario feasibility reviewer",
      "sourceNotebookId": null,
      "sourceNotebookCoverage": "generated-gap-cover",
      "decision": {
        "rank": 6,
        "decisionLane": "lane-4-research-backlog",
        "decisionReadinessScore": 41.42,
        "deterministicUtility": 37.95,
        "promotionState": "blocked-for-commercial-proof",
        "decisionHash": "sha256-8bcef4c6d0b17543fd330abfe053478152e09a623045d677ca24c9f669159934",
        "comparisonHash": "sha256-babeb6d242c117865b431a9a614d7e520e7a9504dc0bb2438273e5329cdbfa2d"
      },
      "uncertainty": {
        "uncertaintyBudgetPoints": 64.95,
        "uncertaintyClass": "high-uncertainty",
        "utilityP10": 34.02,
        "utilityMedian": 37.73,
        "utilityP90": 41.65,
        "topDrivers": [
          {
            "category": "model-spread",
            "label": "Seeded utility downside spread",
            "contributionPoints": 16,
            "evidenceState": "modeled-heuristic",
            "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
            "contributionHash": "sha256-3a6bcd76e44b465731a5a7391ff59f7e8c4b01803bf85738d9eeacfda0260026"
          },
          {
            "category": "assumption-sensitivity",
            "label": "Blocked or sensitive assumptions",
            "contributionPoints": 12.18,
            "evidenceState": "blocked-business-proof",
            "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
            "contributionHash": "sha256-3b063b187963ef7fdcff3cab7471cc8248af9a172602d565ae776b10366e99cc"
          },
          {
            "category": "runtime-sidecar",
            "label": "Trajectory/event/runtime validation gap",
            "contributionPoints": 12,
            "evidenceState": "blocked-runtime-evidence",
            "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
            "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
          },
          {
            "category": "resource-evidence",
            "label": "Body/feedstock composition uncertainty",
            "contributionPoints": 10.4,
            "evidenceState": "blocked-resource-promotion",
            "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
            "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
            "contributionHash": "sha256-9e4d02974fb4ab05d2fb6acbadc7d88c08f2d052378c2f7f7e5bc448f8e84f95"
          }
        ],
        "budgetHash": "sha256-6557cf089ad444fcf5ed0be5797ebfedf1cac7d3b4976f5e92033b629b50e386"
      },
      "economics": {
        "businessReadinessMedian": 53.68,
        "businessReadinessP10": 44.62,
        "businessReadinessP90": 63.86,
        "medianProgramNeedBn": 104.1,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 0,
        "underfundedProbabilityPercent": 11.91
      },
      "sourceRefs": [],
      "artifactIds": [],
      "assumptionRefs": [],
      "openQuestions": [
        "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "Close assumption review gates with source-backed records and rerun assumption impact ledger."
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mercury-polar: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "No source-authored scenario notebook existed in the snapshot; this generated notebook requires reviewer expansion before customer use."
      ],
      "workOrders": [
        {
          "id": "diligence-work-order-01-gap-runtime-orekit-propagation-v1",
          "coverage": "fallback-platform-critical-path-work-order",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "workOrderHash": "sha256-baa82fd4ea74aad62b55dfc56fd78e1513cac8ba3a0e6cbc136c02b3d128e4d1"
        },
        {
          "id": "diligence-work-order-02-gap-runtime-gmat-transfer-v1",
          "coverage": "fallback-platform-critical-path-work-order",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "workOrderHash": "sha256-571ba2ce848959e9016799486d0505720f857685f02a601c2cc09e7f58a3e476"
        },
        {
          "id": "diligence-work-order-03-gap-runtime-tudat-transfer-v1",
          "coverage": "fallback-platform-critical-path-work-order",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "workOrderHash": "sha256-74ae877ca9b3c8c030f093f9b35cfd3239f6069c924c1f0da02bf9b6c1d98710"
        }
      ],
      "evidenceHashes": {
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "sourceNotebookSet": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
      },
      "markdownPath": "public/scenario-notebooks/scenario-notebook-mercury-polar.md",
      "notebookHash": "sha256-db0dc05ff4da7a6438f779964daf0a53990962175df5a6ed658244eeb61a0bbf",
      "markdownHash": "sha256-c0d2b4af8a08243ed251e6a1bfb9fe1d5154be253f7b296ec59213679eb009e9"
    },
    {
      "id": "scenario-notebook-mars-first",
      "scenarioId": "mars-first",
      "scenarioName": "Mars-first Conventional Expansion",
      "title": "Mars-first Conventional Expansion generated review notebook",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "notebookState": "generated-coverage-gap-notebook",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "audience": "scenario feasibility reviewer",
      "sourceNotebookId": null,
      "sourceNotebookCoverage": "generated-gap-cover",
      "decision": {
        "rank": 5,
        "decisionLane": "lane-4-research-backlog",
        "decisionReadinessScore": 41.72,
        "deterministicUtility": 40.78,
        "promotionState": "blocked-for-commercial-proof",
        "decisionHash": "sha256-81bc9923440bb378abb0e1f0e16683f5e7d4df6014535645506f115bb13313bb",
        "comparisonHash": "sha256-faa7e78f6843f4bd8737baf17138a8c33fa941b37102e8c16771079ccb0b77d7"
      },
      "uncertainty": {
        "uncertaintyBudgetPoints": 44.69,
        "uncertaintyClass": "medium-uncertainty",
        "utilityP10": 38.47,
        "utilityMedian": 40.76,
        "utilityP90": 42.8,
        "topDrivers": [
          {
            "category": "runtime-sidecar",
            "label": "Trajectory/event/runtime validation gap",
            "contributionPoints": 12,
            "evidenceState": "blocked-runtime-evidence",
            "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
            "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
          },
          {
            "category": "model-spread",
            "label": "Seeded utility downside spread",
            "contributionPoints": 10.99,
            "evidenceState": "modeled-heuristic",
            "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
            "contributionHash": "sha256-73b99d87c128271af6a24e0fae56a71454d5ace353dec7ee58a332eeb04b00dc"
          },
          {
            "category": "assumption-sensitivity",
            "label": "Blocked or sensitive assumptions",
            "contributionPoints": 7.16,
            "evidenceState": "blocked-business-proof",
            "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
            "contributionHash": "sha256-6d5f5c1fdf60a3c4743279885720f52b7f46f0ffa8c83022379740cce7fad390"
          },
          {
            "category": "source-use-rights",
            "label": "Customer report source-use clearance",
            "contributionPoints": 6.13,
            "evidenceState": "blocked-source-use-review",
            "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
            "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
            "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
          }
        ],
        "budgetHash": "sha256-48d87d02b127f7fc2148ebb78c5d2cef3929bf3650408bb38914aa658a5dd173"
      },
      "economics": {
        "businessReadinessMedian": 63.22,
        "businessReadinessP10": 57.41,
        "businessReadinessP90": 68.72,
        "medianProgramNeedBn": 68.05,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 0,
        "underfundedProbabilityPercent": 1.95
      },
      "sourceRefs": [],
      "artifactIds": [],
      "assumptionRefs": [],
      "openQuestions": [
        "Promote runtime sidecar artifacts through the sidecar validation gate.",
        "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts."
      ],
      "blockers": [
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mars-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mars-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "No source-authored scenario notebook existed in the snapshot; this generated notebook requires reviewer expansion before customer use."
      ],
      "workOrders": [
        {
          "id": "diligence-work-order-01-gap-runtime-orekit-propagation-v1",
          "coverage": "fallback-platform-critical-path-work-order",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "workOrderHash": "sha256-baa82fd4ea74aad62b55dfc56fd78e1513cac8ba3a0e6cbc136c02b3d128e4d1"
        },
        {
          "id": "diligence-work-order-02-gap-runtime-gmat-transfer-v1",
          "coverage": "fallback-platform-critical-path-work-order",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "workOrderHash": "sha256-571ba2ce848959e9016799486d0505720f857685f02a601c2cc09e7f58a3e476"
        },
        {
          "id": "diligence-work-order-03-gap-runtime-tudat-transfer-v1",
          "coverage": "fallback-platform-critical-path-work-order",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "workOrderHash": "sha256-74ae877ca9b3c8c030f093f9b35cfd3239f6069c924c1f0da02bf9b6c1d98710"
        }
      ],
      "evidenceHashes": {
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "sourceNotebookSet": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
      },
      "markdownPath": "public/scenario-notebooks/scenario-notebook-mars-first.md",
      "notebookHash": "sha256-c7495c7e54c0ab6d83ec5472d0410e16010961f395a2749b57d06e0efc1b99bf",
      "markdownHash": "sha256-e24d9a3aa637cbe530a55be3c29a0f345044984d2c94d45f01976ed9323f99e2"
    }
  ],
  "packHash": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685"
}
;
